import React from 'react'

type VideoSectionProps = {
	children: React.ReactNode
	sectionId: string
	backgroundColor?: string // Optional background color prop
	backgroundImage?: string // Optional background image prop (can be .webm or image file)
	gradientBackground?: string // Optional gradient background prop
}

function VideoSection({
	children,
	sectionId,
	backgroundColor,
	backgroundImage,
	gradientBackground,
}: VideoSectionProps) {
	// Check if the backgroundImage is a webm file
	const isVideoBackground = backgroundImage?.endsWith('.webm')

	return (
		<section
			id={sectionId}
			className="relative bg-fixed bg-cover bg-center overflow-hidden"
			style={{
				backgroundColor:
					!gradientBackground && backgroundColor
						? backgroundColor
						: 'transparent',
				backgroundImage:
					!isVideoBackground && gradientBackground
						? gradientBackground
						: undefined, // Only set backgroundImage if it's not a video
			}}
		>
			{/* Background Video */}
			{isVideoBackground && (
				<video
					autoPlay
					loop
					muted
					playsInline
					className="absolute inset-0 w-full h-full object-cover"
				>
					<source src={backgroundImage} type="video/webm" />
					{/* Fallback text */}
					Your browser does not support the video tag.
				</video>
			)}

			{/* Blur Overlay */}
			<div className="absolute inset-0 w-[101%] h-[101%] bg-black bg-opacity-20 backdrop-blur-sm"></div>

			{/* Content */}
			<div className="max-w-[80%] mx-auto flex justify-center py-12 z-10">
				{children}
			</div>
		</section>
	)
}

export default VideoSection
